import { render, staticRenderFns } from "./DictBp.vue?vue&type=template&id=4cdd5823&"
import script from "./DictBp.vue?vue&type=script&lang=js&"
export * from "./DictBp.vue?vue&type=script&lang=js&"
import style0 from "./DictBp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports